/* eslint-disable @typescript-eslint/no-explicit-any */
import { v4 } from 'uuid';

import { ObstructionType } from './enums';
import { RecordData } from '../../helpers-classes';
import { ObstructionData, ObstructionDataIn } from './types';

export const obstructionData = (dataIn: ObstructionDataIn = null): ObstructionData => {
	const rd = new RecordData<ObstructionDataIn>(dataIn);

	const obstructionType = rd.useNewOrDefault<ObstructionType>('type', ObstructionType.Standard);

	const record: ObstructionData = {
		id: rd.useNewOrPartial<string>('id', v4()),
		sku: dataIn?.sku || '',
		type: obstructionType,
		size: dataIn?.size ?? { width: 0, height: 0, depth: 0 },
		axis: dataIn?.axis ?? null,
		connections: dataIn?.connections ?? null,
		trims: dataIn?.trims ?? null,
		panel: dataIn?.panel ?? null,
		surround: dataIn?.surround ?? null
	};

	return record;
};
